<script lang="ts" setup>
import { computed, type CSSProperties } from 'vue'

defineOptions({ name: 'SdFontIcon' })

const props = defineProps({
    prefix: { type: String, default: 'sd-font-icon' },
    name  : { type: String                          },
    size  : { type: Number, default: 16             },
    color : { type: String                          }
})

const iconStyle$ = computed(() => {
    const styles: CSSProperties = {}

    if (props.size) {
        styles.width    = props.size + 'px'
        styles.height   = props.size + 'px'
    }

    if (props.color) {
        styles.color = props.color
    }

    return styles
})
</script>

<template>
    <i :class="`${props.prefix} ${ props.name }`" :style="iconStyle$" />
</template>

